// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getStorage} from 'firebase/storage';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBVfpa0hLGsLbk1X126nnOvqUUF0DdqiKg",
  authDomain: "apple-tree-b2133.firebaseapp.com",
  projectId: "apple-tree-b2133",
  storageBucket: "apple-tree-b2133.appspot.com",
  messagingSenderId: "339249104207",
  appId: "1:339249104207:web:b0754f0018b7017bb1f13a",
  measurementId: "G-YE3ME4MQ13"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const storage = getStorage(app);